export default __webpack_public_path__ + "static/media/billy-pointing-to-phone.ac795dc3.png";